import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "option"];
import { Flex } from 'foundations-components/components/Flex';
import UITooltip from 'UIComponents/tooltip/UITooltip';

// More semantic than `?:` above: these properties are "all or nothing"
import { jsx as _jsx } from "react/jsx-runtime";
export const CustomPipelineSelectOption = _ref => {
  let {
      children,
      option
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(Flex, {
      children: /*#__PURE__*/_jsx(UITooltip, {
        disabled: !(option !== null && option !== void 0 && option.showTooltip),
        placement: (option === null || option === void 0 ? void 0 : option.tooltipPlacement) || 'right',
        title: option === null || option === void 0 ? void 0 : option.tooltipMessage,
        children: children
      })
    })
  }));
};